import {
  Button,
  CircularProgress,
  LinearProgress,
  MenuItem
} from '@material-ui/core'
import i18n from 'i18next'
import { reduxForm, Field } from 'redux-form'
import { UpdateApplicationStatus } from '../../../actions/types'
import ErrorMessage from '../../../components/Error/ErrorMessage'
import { ReduxTextField } from '../../../components/FormInput/ReduxWrappers'
import { ApplicationStatus } from '../../../types/applications'
import { ReduxForm } from '../../../types/forms'

interface UpdateApplicationStatusFormProps extends ReduxForm {
  updateApplicationStatus: UpdateApplicationStatus
  t: i18n.TFunction
}

// wantsContract/tenant have dedicated flows (write contractWantedId/tenantId).
const EXCLUDED_STATUSES = [ApplicationStatus.wantsContract, ApplicationStatus.tenant]
const statusOptions = Object.values(ApplicationStatus).filter(
  (status) => !EXCLUDED_STATUSES.includes(status)
)

const UpdateApplicationStatusForm = ({
  updateApplicationStatus,
  handleSubmit,
  submitting,
  error,
  t
}: UpdateApplicationStatusFormProps) => (
  <form onSubmit={handleSubmit(updateApplicationStatus)}>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap'
      }}
    >
      <Field
        select
        name='status'
        label={t('application.setStatusLabel')}
        component={ReduxTextField}
        variant='outlined'
        size='small'
        style={{ minWidth: 200, backgroundColor: '#fff' }}
      >
        {statusOptions.map((status) => (
          <MenuItem key={status} value={status}>
            {t(`application.status.${status}`)}
          </MenuItem>
        ))}
      </Field>
      <Button
        type='submit'
        variant='contained'
        size='small'
        disabled={submitting}
        style={{
          backgroundColor: '#4f9b44',
          color: '#fff',
          minWidth: 96,
          height: 40,
          boxShadow: 'none'
        }}
      >
        {submitting ? (
          <CircularProgress size={18} style={{ color: '#fff' }} />
        ) : (
          t('application.setStatusButton')
        )}
      </Button>
    </div>
    <ErrorMessage error={error} />
    {submitting && <LinearProgress />}
  </form>
)

export default reduxForm({
  form: 'UpdateApplicationStatusForm'
})(UpdateApplicationStatusForm as any) as any
